import React from 'react';
import { Typography, Divider, Grid, Button, Link, Box, styled } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useNavigate } from 'react-router';
import { addSpacesToCamelCase } from 'utils/commonUtil';
import { gridSpacing } from 'store/constant';
import CustomeMap from 'utils/CustomeMap';
import { InfoOutlined } from '@mui/icons-material';
import MachineImageGallery from './MachineImageGallery';

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  margin: '0 auto',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626'
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959'
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343'
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c'
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff'
  }
}));

export default function OrganizationCard({ machineDetails, RecyclerToggleBoughtRentedAssignedCondition }) {
  const navigate = useNavigate();

  const locationLatLng = machineDetails?.location?.address
    ? {
        lat: machineDetails?.location?.address?.coOrdinates?.latitude || 0,
        lng: machineDetails?.location?.address?.coOrdinates?.longitude || 0,
        label: machineDetails?.location?.address?.fullAddress || 'N.A.'
      }
    : null;

  return (
    <Grid container spacing={gridSpacing} style={{ paddingTop: '15px' }}>
      {/* Buyer Organization Card */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              {(machineDetails?.buyer?.id?.trim() || '') === (machineDetails?.client?.id?.trim() || '')
                ? 'Buyer & Client Organization'
                : 'Buyer Organization'}
            </Typography>
          </div>
          {machineDetails?.buyer !== null ? (
            <>
              <div className="organization_machine_name">
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  {machineDetails?.buyer?.name || 'N.A.'}
                </Typography>
                <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                  {machineDetails?.buyer?.website}
                </Typography>
                <Divider />
                <Typography variant="h4" component="p" className="point_cntct_hd">
                  Point Of Contact{' '}
                </Typography>
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Email :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyer?.mainPOC?.email ? (
                            <Link
                              href={`mailto:${machineDetails?.buyer?.mainPOC?.email}`}
                              sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                              // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                            >
                              {machineDetails?.buyer?.mainPOC?.email}
                            </Link>
                          ) : (
                            'N.A.'
                          )}
                        </Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Phone :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyer?.mainPOC?.phone || 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit', paddingTop: '15px' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Organization Type :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyerOrgType
                            ? Array.isArray(machineDetails?.buyerOrgType) && machineDetails?.buyerOrgType?.length
                              ? machineDetails?.buyerOrgType.join(', ')
                              : addSpacesToCamelCase(machineDetails?.buyerOrgType)
                            : 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <>
              <div style={{ padding: '10px 15px 15px' }}>
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  Not Assigned
                </Typography>
              </div>
            </>
          )}
        </div>
      </Grid>
      {/* Seller Organization Card */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              Seller Organization
            </Typography>
          </div>
          {machineDetails?.seller !== null ? (
            <>
              <div className="organization_machine_name">
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  {machineDetails?.seller?.name || 'N.A.'}
                </Typography>
                <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                  {machineDetails?.seller?.website}
                </Typography>
                <Divider />
                <Typography variant="h4" component="p" className="point_cntct_hd">
                  Point Of Contact{' '}
                </Typography>
                {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {machineDetails?.seller?.name}
                          </Typography> */}
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Email :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.seller?.mainPOC?.email ? (
                            <Link
                              href={`mailto:${machineDetails?.seller?.mainPOC?.email}`}
                              sx={{
                                textDecoration: 'underline',
                                color: 'blue',
                                wordBreak: 'break-word'
                              }}
                              // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                            >
                              {machineDetails?.seller?.mainPOC?.email}
                            </Link>
                          ) : (
                            'N.A.'
                          )}
                        </Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Phone :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.seller?.mainPOC?.phone || 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                {/* <Typography variant="h4" component="p" style={{ fontWeight: 'bold', paddingTop: 15 }}>
                                Organization Types{' '}
                              </Typography> */}
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit', paddingTop: '15px' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Organization Type :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.sellerOrgType
                            ? Array.isArray(machineDetails?.sellerOrgType) && machineDetails?.sellerOrgType?.length
                              ? machineDetails?.sellerOrgType.join(', ')
                              : addSpacesToCamelCase(machineDetails?.sellerOrgType)
                            : 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <>
              <div style={{ padding: '10px 15px 15px' }}>
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  Not Assigned
                </Typography>
              </div>
            </>
          )}
        </div>
      </Grid>
      {/* Client Organization Card  */}
      {!RecyclerToggleBoughtRentedAssignedCondition && (
        <>
          {(machineDetails?.buyer?.id?.trim() || '') !== (machineDetails?.client?.id?.trim() || '') && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
                <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
                  <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                    <Typography
                      component="h4"
                      variant="h3"
                      // sx={{ mr: 1, pb: 1.8 }}
                      sx={{ color: '#fff' }}
                    >
                      Client Organization
                    </Typography>
                  </div>
                  {machineDetails?.client !== null ? (
                    <>
                      <div className="organization_machine_name">
                        <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                          {machineDetails?.client?.name || 'N.A.'}
                        </Typography>
                        <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                          {machineDetails?.client?.website}
                        </Typography>
                        <Divider />
                        <Typography variant="h4" component="p" className="point_cntct_hd">
                          Point Of Contact{' '}
                        </Typography>
                        {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.client?.name}
                              </Typography> */}
                        <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                          <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                            <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                              <div style={{ display: 'inherit' }}>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                  Email :{' '}
                                </Typography>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                  {machineDetails?.client?.mainPOC?.email ? (
                                    <Link
                                      href={`mailto:${machineDetails?.client?.mainPOC?.email}`}
                                      sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                      // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                    >
                                      {machineDetails?.client?.mainPOC?.email}
                                    </Link>
                                  ) : (
                                    'N.A.'
                                  )}
                                </Typography>
                              </div>
                            </div>
                          </Grid>

                          <Grid item xs={12} sx={{ padding: 0 }}>
                            <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                              <div className="" style={{ display: 'inherit' }}>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                  Phone :{' '}
                                </Typography>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                  {machineDetails?.client?.mainPOC?.phone || 'N.A.'}
                                </Typography>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ padding: '10px 15px 15px' }}>
                        <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                          Not Assigned
                        </Typography>
                      </div>
                    </>
                  )}
                </div>
              </Grid>
            </>
          )}

          {/* Recycler Organization Card */}
          <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
            <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
              <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                <Typography
                  component="h4"
                  variant="h3"
                  // sx={{ mr: 1, pb: 1.8 }}
                  sx={{ color: '#fff' }}
                >
                  Recycler Organization
                </Typography>
              </div>
              {machineDetails?.recycler !== null ? (
                <>
                  <div className="organization_machine_name">
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      {machineDetails?.recycler?.name || 'N.A.'}
                    </Typography>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                      {machineDetails?.recycler?.website}
                    </Typography>
                    <Divider />
                    <Typography variant="h4" component="p" className="point_cntct_hd">
                      Point Of Contact{' '}
                    </Typography>
                    {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.recycler?.name}
                              </Typography> */}
                    <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                      <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Email :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.recycler?.mainPOC?.email ? (
                                <Link
                                  href={`mailto:${machineDetails?.recycler?.mainPOC?.email}`}
                                  sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                  // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                >
                                  {machineDetails?.recycler?.mainPOC?.email}
                                </Link>
                              ) : (
                                'N.A.'
                              )}
                            </Typography>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} sx={{ padding: 0 }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div className="" style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Phone :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.recycler?.mainPOC?.phone || 'N.A.'}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/Recycler', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'modify',
                                orgObj: machineDetails?.recycler || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(132,194,223)' }}
                        >
                          <EditIcon />
                          &nbsp; Modify Recycler
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ padding: '10px 15px 15px' }}>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      Not Assigned
                    </Typography>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/Recycler', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'assign',
                                orgObj: machineDetails?.recycler || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(56,135,208)' }}
                        >
                          <PersonAddAltIcon />
                          &nbsp; Assign Recycler
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>

          {/* Service Provider Organization Card  */}
          <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
            <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
              <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                <Typography
                  component="h4"
                  variant="h3"
                  // sx={{ mr: 1, pb: 1.8 }}
                  sx={{ color: '#fff' }}
                >
                  Service Provider Organization
                </Typography>
              </div>
              {machineDetails?.serviceProvider !== null ? (
                <>
                  <div className="organization_machine_name">
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      {machineDetails?.serviceProvider?.name || 'N.A.'}
                    </Typography>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                      {machineDetails?.serviceProvider?.website}
                    </Typography>
                    <Divider />
                    <Typography variant="h4" component="p" className="point_cntct_hd">
                      Point Of Contact{' '}
                    </Typography>
                    {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.serviceProvider?.name}
                              </Typography> */}
                    <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                      <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Email :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.serviceProvider?.mainPOC?.email ? (
                                <Link
                                  href={`mailto:${machineDetails?.serviceProvider?.mainPOC?.email}`}
                                  sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                  // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                >
                                  {machineDetails?.serviceProvider?.mainPOC?.email}
                                </Link>
                              ) : (
                                'N.A.'
                              )}
                            </Typography>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} sx={{ padding: 0 }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div className="" style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Phone :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.serviceProvider?.mainPOC?.phone || 'N.A.'}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/ServiceProvider', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'modify',
                                orgObj: machineDetails?.serviceProvider || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(132,194,223)' }}
                        >
                          <EditIcon />
                          &nbsp; Modify Service Provider
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ padding: '10px 15px 15px' }}>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      Not Assigned
                    </Typography>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/ServiceProvider', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'assign',
                                orgObj: machineDetails?.serviceProvider || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(86,135,208)' }}
                        >
                          <PersonAddAltIcon />
                          &nbsp; Assign Service Provider
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>
        </>
      )}

      {/* Machine Map View */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px', marginBottom: 0 }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              Machine Map View
            </Typography>
          </div>
          <div>
            {locationLatLng ? (
              <Box className="machine-map">
                <CustomeMap locationLatLng={locationLatLng} />
              </Box>
            ) : (
              <Box sx={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h4" component={'div'}>
                  <InfoOutlined sx={{ color: 'rgb(56, 135, 208)', position: 'relative', top: '5px' }} /> Location is not Added
                </Typography>
              </Box>
            )}
          </div>
        </div>
      </Grid>

      {/* Machine Image Gallery */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px', marginBottom: 0 }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              Machine Image
            </Typography>
          </div>
          <div className="machine-images">
            {machineDetails?.images && Array.isArray(machineDetails?.images) && machineDetails?.images?.length ? (
              <MachineImageGallery galleryImgArr={machineDetails?.images || []} />
            ) : (
              // <Box sx={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              //   <Typography variant="h4" component={'div'}>
              //     <InfoOutlined sx={{ color: 'rgb(56, 135, 208)', position: 'relative', top: '5px' }} /> No Image Found!
              //   </Typography>
              // </Box>
              <StyledGridOverlay>
                <svg style={{ flexShrink: 0 }} width="240" height="200" viewBox="0 0 184 152" aria-hidden focusable="false">
                  <g fill="none" fillRule="evenodd">
                    <g transform="translate(24 31.67)">
                      <ellipse className="ant-empty-img-5" cx="67.797" cy="106.89" rx="67.797" ry="12.668" />
                      <path
                        className="ant-empty-img-1"
                        d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                      />
                      <path
                        className="ant-empty-img-2"
                        d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                      />
                      <path
                        className="ant-empty-img-3"
                        d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                      />
                    </g>
                    <path
                      className="ant-empty-img-3"
                      d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                    />
                    <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                      <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                      <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                    </g>
                  </g>
                </svg>
                <Box sx={{ mt: 1 }}>Machine Image Not Found!</Box>
              </StyledGridOverlay>
            )}
          </div>
        </div>
      </Grid>
      {/* Rental Organization - Off */}
      {/* {machineDetails &&
                      loginUser &&
                      orgType &&
                      machineDetails?.buyerOrgType === 'Recycler' &&
                      machineDetails?.client?.id === loginUser?.organization?.id &&
                      orgType === 'Enterprise' && (
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '400px' }}>
                            <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                              <Typography
                                component="h4"
                                variant="h3"
                                // sx={{ mr: 1, pb: 1.8 }}
                                sx={{ color: '#fff' }}
                              >
                                Rental Organization
                              </Typography>
                            </div>
                            {machineDetails?.buyer !== null ? (
                              <>
                                <div style={{ padding: '10px 15px 15px' }}>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                                    {machineDetails?.buyer?.name || 'N.A.'}
                                  </Typography>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                                    {machineDetails?.buyer?.website}
                                  </Typography>
                                  <Divider />
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold', paddingTop: 15 }}>
                                    Point Of Contact{' '}
                                  </Typography>
                                  <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                                    <Grid item xs={12} sx={{ padding: 0 }}>
                                      <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                                        <div className="address_locationmain" style={{ margin: '2px', padding: '5px', display: 'inherit' }}>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                            Email :{' '}
                                          </Typography>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                            {machineDetails?.buyer?.mainPOC?.email ? (
                                              <Link
                                                href={`mailto:${machineDetails?.buyer?.mainPOC?.email}`}
                                                sx={{ textDecoration: 'underline', color: 'blue' }}
                                                // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                              >
                                                {machineDetails?.buyer?.mainPOC?.email}
                                              </Link>
                                            ) : (
                                              'N.A.'
                                            )}
                                          </Typography>
                                        </div>
                                      </div>
                                    </Grid>
    
                                    <Grid item xs={12} sx={{ padding: 0 }}>
                                      <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                                        <div className="address_locationmain" style={{ margin: '2px', padding: '5px', display: 'inherit' }}>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                            Phone :{' '}
                                          </Typography>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                            {machineDetails?.buyer?.mainPOC?.phone || 'N.A.'}
                                          </Typography>
                                        </div>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            ) : (
                              <>
                                <div style={{ padding: '10px 15px 15px' }}>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                                    Not Assigned
                                  </Typography>
                                </div>
                              </>
                            )}
                          </div>
                        </Grid>
                      )} */}
    </Grid>
  );
}
